module.exports = __webpack_public_path__ + "img/total-docs.c814afab.svg";